import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import {
  xdlColorSelected,
  xdlColorControlFillTertiary,
  xdlPaletteGrayCool06,
  spaceL,
  spaceM,
} from '@xing-com/tokens';

export const StyledWrapper = styled.div`
  position: relative;
  width: 340px;
  height: 55px;
  margin-top: ${spaceL};
  margin-left: ${spaceM};

  @media (max-aspect-ratio: 8/5) {
    display: none;
  }
`;

export const StyledZoomInButton = styled(TextButton)`
  right: 10px;
  bottom: 0;
  white-space: nowrap;
  position: absolute;
`;

export const StyledZoomOutButton = styled(StyledZoomInButton)`
  left: 10px;
  right: auto;
`;

export const StyledBar = styled.input`
  position: absolute;
  top: 0;
  width: 100%;
  appearance: none;
  background: transparent;
  cursor: pointer;
  height: 6px;

  &::-webkit-slider-thumb {
    appearance: none;
    height: 24px;
    width: 24px;
    background-color: ${xdlColorSelected};
    border-radius: 50%;
  }

  &::-moz-range-thumb {
    border: none;
    height: 24px;
    width: 24px;
    background-color: ${xdlColorSelected};
    border-radius: 50%;
  }
`;

export const StyledStepsBarBackground = styled.div`
  position: absolute;
  top: 0;
  width: calc(100% - 20px);
  height: 6px;
  background-color: ${xdlColorControlFillTertiary};
  margin: 0 10px;
`;

export const StyledStepsBarCurrent = styled.div<{ $zoomOffset: number }>`
  position: absolute;
  width: ${({ $zoomOffset }) =>
    `calc(${$zoomOffset}% - ${
      (1 / 6) * $zoomOffset
    }px)`}; /* The bar is shifted by 10px on each side and the width must be shortened proportionally to the current zoom value */
  top: 0;
  left: 10px;
  height: 6px;
  background-color: ${xdlColorSelected};
`;

export const StyledStepMarkers = styled.div`
  position: absolute;
  top: 1px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
`;

export const StyledStepMarker = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${xdlPaletteGrayCool06};
`;
